import type { ElementType } from 'react'
import {
  Activity,
  Banknote,
  Barcode,
  Building2,
  ClipboardList,
  Clock,
  Database,
  FileText,
  FolderOpen,
  Gift,
  GitBranch,
  LayoutDashboard,
  LayoutGrid,
  Package,
  PieChart,
  Printer,
  Receipt,
  Settings,
  Shield,
  ShieldUser,
  ShoppingBag,
  ShoppingCart,
  Sparkles,
  Tag,
  Truck,
  Users,
  UtensilsCrossed,
  Warehouse,
} from 'lucide-react'

const sidebarIconMap: Record<string, ElementType> = {
  'las la-tachometer-alt': LayoutDashboard,
  'ri-shopping-cart-line': ShoppingCart,
  'las la-boxes': Package,
  'ri-store-2-line': Warehouse,
  'ri-barcode-line': Barcode,
  'ri-folder-line': FolderOpen,
  'ri-shopping-bag-line': ShoppingBag,
  'ri-user-line': Users,
  'ri-price-tag-3-line': Tag,
  'ri-file-list-line': FileText,
  'ri-clipboard-fill': ClipboardList,
  'ri-node-tree': GitBranch,
  'ri-settings-line': Settings,
  'ri-database-2-line': Database,
  'ri-file-list-3-line': Activity,
  'ri-printer-line': Printer,
  'ri-truck-line': Truck,
  'ri-receipt-line': Receipt,
  'ri-bank-line': Banknote,
  'ri-funds-line': PieChart,
  'ri-gift-line': Gift,
  'ri-building-line': Building2,
  'ri-layout-grid-line': LayoutGrid,
  'ri-safe-2-line': Shield,
  'ri-time-line': Clock,
  'ri-restaurant-line': UtensilsCrossed,
  'ri-shield-user-line': ShieldUser,
  'ri-arrow-go-back-line': ClipboardList,
  'ri-checkbox-circle-line': ClipboardList,
  'ri-edit-circle-line': ClipboardList,
  'ri-exchange-line': GitBranch,
  'ri-shapes-line': Tag,
  'ri-star-line': Tag,
  'ri-wallet-3-line': Banknote,
  'ri-bank-card-line': Banknote,
  'ri-file-text-line': FileText,
  'ri-calendar-line': Clock,
  'ri-steering-2-line': Truck,
  'ri-money-cny-circle-line': Banknote,
  'ri-fire-line': UtensilsCrossed,
  'ri-refresh-line': Activity,
  'ri-money-dollar-circle-line': Banknote,
  'ri-flask-line': Package,
  'ri-sparkling-line': Sparkles,
  'ri-file-transfer-line': FileText,
}

export function resolveSidebarIcon(icon?: string): ElementType {
  if (!icon) return LayoutDashboard
  return sidebarIconMap[icon] ?? LayoutDashboard
}

export { sidebarIconMap }
